import React, {useState,useEffect,useRef,useContext} from 'react';
import {Modal} from 'react-bootstrap'
import ConexContext from "../../context/ConexContext";
import * as fCampos from "../JS/campos";

// import apps from "../assets/img/categoria.svg";
import aspa from "../../assets/img/aspacierre.svg";
import cerrar from "../../assets/img/cerrar.svg";
import icon1 from "../../assets/img/agregaciones1.svg";
import closeall from "../../assets/img/closeall.svg";



const ModalAgrega = (props) => {

	const {tipo_usuario}=useContext(ConexContext);
	// STATES
	const [copyConf, setCopyConf] = useState(null); //copia del conf para jugar con él hasta que se le de a aplicar
	const [search, setSearch] = useState(""); // para la busqueda
	const [copyConfs, setCopyConfs] = useState(null); //copia del confs para jugar con él hasta que se le de a aplicar
	const [msgError, setMsgError] = useState(""); // mensaje de error si no se ha seleccionado nada
	// REF
	const buscador = useRef();
  
	// VARIABLES
	const agregaciones_maximo=(tipo_usuario==='5'?7:6);
	let archivo=require('../../config/agregaciones.json');
  
	// FUNCIONES
	// Para cerrar el modal
	function cierra() {
		setMsgError("");
	  props.onHide();
	}
	// Para capturar los cambios de datos del estado de la busqueda
	const handleChange = (event) => {
	  setSearch(event.target.value);
	}
	// Para hacer el filtro de la busqueda por nombre
	function filtroCampos(elem) {
	  if (
		copyConf[elem].agregaciones & //el campo es para mostrar en campos      
		copyConf[elem].Titulo.toLowerCase().includes(search.toLowerCase()) // filtro de búsqueda    
		) {
		return true;
	  }
	  return false;
	}
	// Effec para cada vez que abre y cierra el modal
	useEffect(() => {
	  //Se acaba de abrir
	  if(props.show){
	  setSearch("");
		setMsgError("");
	  setCopyConf(fCampos.copy(props.agregaciones));
	  setCopyConfs(fCampos.copy(props.Confs));
	  }
	}, [props.show, props.agregaciones, props.Confs]);
	
	//Elimina el mensaje de error si se ha seleccionado una agregación
	useEffect(() => {
		if(!copyConfs) return;
	  if(copyConfs.agregaciones.length>0){
			setMsgError("");
	  }
	}, [copyConfs]);

	if (!props.show|!copyConf|!props.agregaciones|!copyConfs| (props.agregaciones.length >= 1))
		return("")
	else
	return (
	  
	  <Modal
		show={props.show}
		onHide={props.onHide}
		animation={false}
		centered
		size="lg"
		className="modal_agregaciones"
	  >
		
		<div id="modalcampos">
		  <Modal.Body>
			<div className="contmodal fondoazul modales_campos col-xs-12">
			
			<div className="col-xs-12 nopadding" >

					<div className="col-xs-6 nopadding" >
						<div className="titular_modal mt-n1">
							<img src={icon1} alt="icono" className="icocampos" />
							<h2>Agrupar Por</h2>	
						</div>
					</div>
					
					<div className="col-xs-6 nopadding" >
						<div className="contaspacierre">
							<div
							onClick={() => {
								cierra();
							}}
							className="aspacierre"
							>
							<img src={cerrar} alt="cerrar" className="icocerrar" />
							</div>
						</div>
					</div>
					
			  </div>
  
			  <div className="col-xs-12 nopadding">
				<h4>Agrupaciones seleccionadas<strong> {copyConfs.agregaciones.length} de {agregaciones_maximo}</strong></h4>
			  </div>
  
			  <div className="cont_fondocampos col-xs-12 nopadding">
				<div className="fondocampos col-xs-12">
				  <ul>
					  {
						copyConfs.agregaciones && 
						Object.keys(copyConfs.agregaciones).map(
						  (elem) => (
							<li
								className="filtro_added"
								onClick={() => {}}
								key={elem}
							  >
								<>
								  <div className="ciz">
									  <h5>{archivo[copyConfs.agregaciones[elem]].Titulo}</h5>
									  <small>{archivo[copyConfs.agregaciones[elem]].Descripcion}</small>
								  </div>
								  <div className="cde">
									<span>
									  <img
										onClick={() => {
											let aux ={...copyConfs};
											aux.agregaciones = aux.agregaciones.filter(function(i) { return i !== copyConfs.agregaciones[elem] }); // filtramos                               
											setCopyConfs(aux);
											copyConf && Object.keys(copyConf).forEach(id=>{
												if (copyConf[id].nombre===copyConfs.agregaciones[elem]) copyConf[id].seleccionado=false;
											})
										}}
										src={aspa}
										alt="cerrar filtro"
									  />
									</span>
								  </div>
								</>
							  </li>
							)
						)}
				  </ul>
				</div>
					<div className="col-xs-12 btn_quitartodos conbtn">
						<button
							onClick={() => {
								let aux ={...copyConfs};
								aux.agregaciones= [];
								setCopyConfs(aux);
								aux = {...copyConf};
								Object.keys(aux).forEach(id=>{
									aux[id].seleccionado=false;
								})
								setCopyConf(aux);
							}}
							className="btn_quitartodos"
						>
							Quitar todas
							<span>
							{" "}
							<img
								src={closeall}
								alt="quitar todos"
								className="icocampos"
							/>
							</span>
						</button>
					</div>
			  </div>
  
			  <div className="col-xs-12 nopadding">
				<hr />
			  </div>
			  <div className="col-xs-12 nopadding">
				<div className="categorias col-xs-12">
				  <div className="cabecera nopadding col-xs-12">
					<div className="nopadding col-xs-6">
					  <input
						ref={buscador}
						type="search"
						id="site-search"
						name=""
						placeholder="Buscar"
						className="mr-2"
						onChange={handleChange}
						defaultValue={search}
					  />
					  en{" "}
					  <strong>
						{copyConf ? (
						  Object.keys(copyConf).filter(filtroCampos).length
						) : (
						  <p>0</p>
						)}
					  </strong>{" "}
					  agrupaciones
					</div>
					<div className="nopadding col-xs-6">
					  {/* <img src={apps} alt="apps" /> */}
					</div>
				  </div>
				  <div className="cont_fondocampos_bd col-xs-12">
					<div className="fondocampos col-xs-12">
					  <ul>
						{copyConf &&
						  Object.keys(copyConf)
							.filter(filtroCampos).filter((elem) => {
								return archivo[copyConf[elem].nombre].Titulo === "Entidad" ? tipo_usuario === "5" : true;
							})
							.map(
							  (elem) =>
								copyConf[elem].agregaciones &&
								copyConf[elem].tipo === "agregaciones" &&(
								  <li
									className="filtro_added"
									onClick={() => {
									  if (copyConf[elem].seleccionado) {
										copyConf[
										  elem
										].seleccionado = false;
										let aux ={...copyConfs};
										aux.agregaciones = aux.agregaciones.filter(function(i) { return i !== copyConf[elem].nombre }); // filtramos
										setCopyConfs(aux);
									  } else {
										// if(props.Confs.agregaciones.length<agregaciones_maximo){
										copyConf[
										  elem
										].seleccionado = true;
										setCopyConf(copyConf);
										let aux ={...copyConfs};
										aux.agregaciones.push(copyConf[elem].nombre);
										setCopyConfs(aux);
									  // }
									}
									}}
									key={elem}
									style={{cursor:'pointer'}}
								  >
									<>
									  <div className="ciz">
									  <h5>{archivo[copyConf[elem].nombre].Titulo}</h5>
									  <small>{archivo[copyConf[elem].nombre].Descripcion}</small>
									  </div>
									</>
									<div className="cde">
									  <input
										type="checkbox"
										onChange={() => {}}
										id={copyConf[elem].nombre}
										checked={copyConf[elem].seleccionado}
									  />
									</div>
								  </li>
								)
							)}
					  </ul>
					</div>
				  </div>
				</div>
			  </div>
			</div>
			<div className='error2 col-xs-12'><span>{msgError}</span></div>
		  </Modal.Body>
		</div>
  
		<Modal.Footer>
			
		  <button
			className="cancelar"
			style={{ width: "18%" }}
			onClick={() => {            
			  props.onHide();
			}}
		  >
			Cancelar
		  </button>
		  <button
			className="aplicar"
			style={{ width: "18%" }}
			onClick={() => {
				if(copyConfs.agregaciones.length===0){
					setMsgError("Se debe seleccionar al menos una agregación");
					return;
				}
				props.setCargando(true);
				props.setAgregaciones(copyConf);
				props.setConfs(copyConfs);
				// props.setactualizar(true);
				props.onHide();
			}}
		  >
			Aplicar
		  </button>
		</Modal.Footer>
	  </Modal>
	);
  };
 
export default ModalAgrega;